(() => {
  const originalFetch = window.fetch && window.fetch.bind(window);
  if (!originalFetch) return;

  window.fetch = (input, init) => {
    const requestUrl = typeof input === 'string' ? input : input && input.url;

    // Shrine's bundled main.js calls this loopback URL during normal page load.
    // A storefront has no reason to contact a customer's local machine, and
    // modern browsers surface that attempt as a Local Network Access prompt.
    if (requestUrl === 'https://localhost/blocked') {
      return Promise.resolve(new Response(null, { status: 204 }));
    }

    return originalFetch(input, init);
  };
})();
